/** Example
 * const input = "123456789012345"
 * const blockSize = 4
 * const resultadoReversa = reverseBlockSplit(input, blockSize)
 * console.log(resultadoReversa) // 123 4567 8901 2345
 */

export function reverseBlockSplit(inputString: string, blockSize: number) {
  let separatedString = ""

  for (let i = inputString.length; i > 0; i -= blockSize) {
    const start = Math.max(i - blockSize, 0)
    const block = inputString.substring(start, i)
    separatedString = `${block} ${separatedString}`
  }

  return separatedString.trim()
}
